/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/autocomplete'

export const AUTOCOMPLETE_SEARCH_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'AUTOCOMPLETE_SEARCH_SUCCESS'
)
export const SEARCH_RESULTS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'SEARCH_RESULTS_SUCCESS'
)
export const SEARCH_QUERY_SAVE = ReduxHelpers.Types.createActionType(
  prefix,
  'SEARCH_QUERY_SAVE'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const DISPOSE = ReduxHelpers.Types.createActionType(prefix, 'DISPOSE')
export const SET_SESSION = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_SESSION'
)
export const DISPOSE_SESSION = ReduxHelpers.Types.createActionType(
  prefix,
  'DISPOSE_SESSION'
)

export const CHANGE_BATCH_SIZE = ReduxHelpers.Types.createActionType(
  prefix,
  'CHANGE_BATCH_SIZE'
)
